var map = {
	"./de-DE.svg": 32969,
	"./en-GB.svg": 23242,
	"./en-US.svg": 61591,
	"./es-ES.svg": 79879,
	"./fr-FR.svg": 77162,
	"./it-IT.svg": 51375,
	"./ru-RU.svg": 26000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15403;